import { createContext } from 'react'
import type { Dispatch, ReactNode, SetStateAction } from 'react'

// Consumed by useOverlayFooter — lets content components inject footer content
// without requiring the parent caller to know about the button's logic
export const OverlayFooterContext = createContext<Dispatch<SetStateAction<ReactNode>> | null>(null)
